import {schema} from 'normalizr';
import schemaWidgets from "../widget/schema";
import schemaClients from "../client/schema";
import schemaSmtps from "../smtp/schema";

export default new schema.Entity('user', {
  widgets: [schemaWidgets],
  clients: [schemaClients],
  smtps: [schemaSmtps],
});